module.exports = __webpack_public_path__ + "static/media/Egypt_manufacturing_business_guide_wbn_b2b_export_suppliers.573dd357.svg";